import React from 'react';
import Applyforworks from "../Learners_data/Applynow/embeddedSystems/Apply-for-works";

const ApplyWorks = () => {
    return (
        <div className='mylearningpaths'>
            <Applyforworks />
        </div>
    );
};

export default ApplyWorks;